/**
 * Layout constants for chip visibility calculation in BaseAutocomplete.
 */
export const CHIP_MIN_WIDTH = 100; // Minimum chip width - chips won't squash below this
export const CHIP_MAX_WIDTH = 180; // Maximum chip width - prevents chips from being too wide
export const COUNT_CHIP_WIDTH = 56; // Width of the "+N" count chip
export const CHIP_GAP = 4; // Gap between chips
export const INPUT_MIN_WIDTH = 60; // Minimum width reserved for the input field
export const END_ADORNMENT_WIDTH = 72; // Approximate width of clear + dropdown buttons
